{
  "login": {
    "title": "Login",
    "subtitle": "Please enter your login data",
    "forgot_password": "Do not remember password?",
    "login": "Login"
  },
  "forgot_password": {
    "title": "Forgot password",
    "subtitle": "Please enter the data to recover password",
    "login_page": "login page",
    "or ": "or"
  },
  "reset_code": {
    "title": "Reset password code",
    "subtitle": "Please enter the code sent to your email",
    "nothing_received": "nothing received"
  },
  "reset_password": {
    "title": "Reset password",
    "subtitle": "Please enter the new password for your account"
  }
}
